var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"AccoundNumberInfo"},[(_vm.bindRouter == 'wechat')?_c('wechatBind',{attrs:{"open":_vm.open}}):_vm._e(),(_vm.bindRouter == 'email')?_c('bindEmail'):_vm._e(),(_vm.bindRouter == 'mobile')?_c('mobileBind'):_vm._e(),(_vm.bindRouter == 'password')?_c('passwordBind'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }